export default {
  menuAdmin: 'quản lý danh mục',
  menuList: 'danh sách danh mục',
  addMeun: 'thêm danh mục',

  table: {
    menuName: ' tên danh mục',
    menuNameVn: 'tên danh mục tiếng Việt',

    menuNameEn: 'Tên danh mục tiếng anh',
    menuCode: ' mã số danh mục',
    menuGrade: ' cấp bậc danh mục',
    menuParent: '  mã danh mục chính',
    menuParentName: ' tên danh mục chính',
    menuStatus: ' trạng thái danh mục',
    autoTransIn: 'Tự động chuyển',
    menuUrl: ' danh mục url',
    apiUrl: ' danh mục apiurl',
    compileMenu: '  sửa danh mục',
    addMenu: ' thêm danh mục',
    sort: 'Sắp xếp'
  },

  data: {
    LevelOnemenu: 'Danh mục cấp độ 1',
    LevelTwomenu: ' Danh mục cấp độ 2',
    LevelThreebutton: ' Danh mục cấp độ 3',
    checkmenuGrade: '  vui lòng chọn cấp độ menu',
    checkmenuCode: ' vui lòng nhập mã menu',
    checkmenuName: ' vui lòng nhập tên menu',
    checkmenuNameVn: ' vui lòng nhập tên tiếng Việt của menu',

    checkmenuNameEn: 'vui lòng nhập tên danh mục tiếng anh',

    menuUrl: ' vui lòng nhập menuURL',
    apiUrl: ' vui lòng nhập menuapiurl',
    addMenuSucceed: ' thêm danh mụcthành công',
    addMenuError: ' thêm danh mục thất bại',
    changMenuSucceed: ' sửa đổi danh mục thành công',
    changMenuError: ' sửa đổi danh mục thất bại',
    sort: 'Vui lòng điền vào sắp xếp'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/menumanage.js